import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { scrollToSection } from "@/lib/api";

export const Footer = () => {
  return (
    <footer className="relative overflow-hidden bg-[#0B3B75] text-white">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark onClick={() => scrollToSection("hero")} />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-white/70">
              Araç sahiplerini yerinde araç yıkama ve detailing hizmeti veren
              partnerlerle buluşturan dijital pazar yeri.
            </p>
            <button
              data-testid="footer-cta"
              onClick={() => scrollToSection("basvuru")}
              className="mt-7 inline-flex rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#0B3B75] hover:bg-[#22C7D6] hover:text-white transition-colors"
            >
              Partner Başvurusu Yap
            </button>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#22C7D6]">Keşfet</p>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75">
              <li><button data-testid="footer-nasil" onClick={() => scrollToSection("nasil-calisir")} className="hover:text-white">Nasıl Çalışır?</button></li>
              <li><button data-testid="footer-partner" onClick={() => scrollToSection("basvuru")} className="hover:text-white">Partner Ol</button></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#22C7D6]">Kurumsal</p>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75">
              <li><Link data-testid="footer-gizlilik" to="/gizlilik" className="hover:text-white">Gizlilik Politikası</Link></li>
              <li><Link data-testid="footer-kvkk" to="/kvkk" className="hover:text-white">KVKK Aydınlatma Metni</Link></li>
              <li><a data-testid="footer-iletisim" href="mailto:partner@yikagel.com" className="hover:text-white">İletişim</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-white/10 pt-8">
          <p className="font-heading text-[16vw] leading-none font-black tracking-tighter text-white/5 sm:text-[10rem]">
            YıkaGel
          </p>
          <p className="mt-2 text-sm text-white/60">© 2026 YıkaGel. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};
